var pug = require("!../../../node_modules/pug-runtime/index.js");

function template(locals) {var pug_html = "", pug_mixins = {}, pug_interp;pug_html = pug_html + "\u003Cp\u003Ephone works!\u003C\u002Fp\u003E";;return pug_html;};
module.exports = template;